export interface ParticipantRegistrationModel {
  token: string;
  password: string;
  confirmPassword: string;
  userAgreement: boolean
  newsletterOptIn: boolean
}
